import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import Header from '../common/Header/Header';
import Enrollment from './EnrollmentRequests/Enrollment';
import './Approval.scss';
import SelfRegistrationFilterScreen from './ProviderSelfRegistation/SelfRegistartionFilterScreen';
import { useLocation } from 'react-router-dom';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

const Approval = () => {
  //TODO: implement persmission
  const isRegistrationPermissionAllowed = true;
  const location = useLocation();
  const [selectedTabLocal, setSelectedTabLocal] = useState('affiliation');
  const tab = location?.state?.tab
    ? location.state.tab
    : location?.state?.previousState?.tab
    ? location?.state?.previousState?.tab
    : location?.state
    ? location?.state
    : 'affiliation';
  const previousListData = location?.state?.tab
    ? location?.state
    : location?.state?.previousState;

  useEffect(() => {
    setSelectedTabLocal(tab || 'affiliation');
  }, [location?.state]);

  const tabClickHandler = (e) => {
    setSelectedTabLocal(e);
  };

  return (
    <div className="approval-container">
      <div className="container-offset border-top ">
        <Header linkTo={'/admin/admin-dashboard'} header="Review Request(s)" />
      </div>
      <div className="mt-3">
        <Tabs
          activeKey={selectedTabLocal}
          defaultActiveKey="enrollment"
          id="uncontrolled-tab-example"
          className="tabs-class-admin"
          onSelect={tabClickHandler}
        >
          {/*<Tab eventKey="enrollment" title="Enrollment (Members)">
            {selectedTabLocal === 'enrollment' && (
              <Enrollment selectedTabLocal={selectedTabLocal} />
            )}
          </Tab>

          <Tab eventKey="registration" title="Self Registration (Providers)">
            {selectedTabLocal === 'registration' && (
              <SelfRegistrationFilterScreen
                selectedTabLocal={selectedTabLocal}
                previousData={previousListData}
              />
            )}
          </Tab>*/}
          {/*isRegistrationPermissionAllowed && (
            <Tab eventKey="memberRegistration" title="Registration">
              {selectedTabLocal === 'memberRegistration' &&
                isRegistrationPermissionAllowed && (
                  <Enrollment selectedTabLocal={selectedTabLocal} />
                )}
              {selectedTabLocal === 'memberRegistration' &&
                !isRegistrationPermissionAllowed && (
                  <div className="container-offset pt-4">
                    <div className="claims-no-data text-center">
                      <CustomClientError
                        CustomClasses="p-0 m-0"
                        ErrorHeading="No Provider Login request found!"
                        ErrorMessage="We could not find any Provider Login request for the selected filter(s).
Use another filter(s) and try again."
                      />
                    </div>
                  </div>
                )}
            </Tab>
          )*/}
          <Tab eventKey="affiliation" title="Affiliation">
            {selectedTabLocal === 'affiliation' && (
              <Enrollment selectedTabLocal={selectedTabLocal} />
            )}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Approval;
